import { render, staticRenderFns } from "./CompsList.vue?vue&type=template&id=6b027a88&scoped=true&"
import script from "./CompsList.vue?vue&type=script&lang=js&"
export * from "./CompsList.vue?vue&type=script&lang=js&"
import style0 from "./CompsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompsList.vue?vue&type=style&index=1&id=6b027a88&lang=scss&scoped=true&"
import style2 from "./CompsList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b027a88",
  null
  
)

export default component.exports